(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('measurementUnits', {
            parent: 'masterData',
            url: '/measurementUnits',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_ACCOUNTING_DEP']
            },
            views: {
                'content@': {
                    templateUrl: 'app/masterData/measurementUnits/measurementUnits.html',
                    controller: 'MDMeasurementUnitsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('masterData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
